import { useSelector } from "react-redux";

const ProtectedFeature = ({ permission, children }) => {
  const permissions = useSelector((state) => state.auth.permissions);
  const user = useSelector((state) => state.auth.user);

  if (!permission) return children;
  // Super Admin (1) and Admin (2) bypass permission checks
  if (user?.RoleId === 1 || user?.RoleId === 2) return children;
  // An array means "any of these" — the same rule PermissionRoute uses. A plain
  // `includes` on an array argument is always false, so a caller passing one would
  // have silently hidden the feature from everyone but Admin.
  const anyOf = Array.isArray(permission) ? permission : [permission];
  if (permissions && anyOf.some((p) => permissions.includes(p))) return children;

  return null;
};

export default ProtectedFeature;
